const countryCodes = [
    { name: "United States", code: "US", dial_code: "+1" },
    // { name: "Canada", code: "CA", dial_code: "+1" },
    { name: "United Kingdom", code: "GB", dial_code: "+44" },
    { name: "Australia", code: "AU", dial_code: "+61" },
    { name: "New Zealand", code: "NZ", dial_code: "+64" },
    { name: "India", code: "IN", dial_code: "+91" },
    { name: "United Arab Emirates", code: "AE", dial_code: "+971" },
    { name: "Singapore", code: "SG", dial_code: "+65" },
    { name: "Germany", code: "DE", dial_code: "+49" },
    { name: "France", code: "FR", dial_code: "+33" },
    { name: "Italy", code: "IT", dial_code: "+39" },
    { name: "Spain", code: "ES", dial_code: "+34" },
    { name: "Portugal", code: "PT", dial_code: "+351" },
    { name: "Netherlands", code: "NL", dial_code: "+31" },
    { name: "Sweden", code: "SE", dial_code: "+46" },
    { name: "Norway", code: "NO", dial_code: "+47" },
    { name: "Denmark", code: "DK", dial_code: "+45" },
    { name: "Finland", code: "FI", dial_code: "+358" },
    { name: "Switzerland", code: "CH", dial_code: "+41" },
    { name: "Ireland", code: "IE", dial_code: "+353" },
    { name: "Brazil", code: "BR", dial_code: "+55" },
    { name: "Argentina", code: "AR", dial_code: "+54" },
    { name: "Mexico", code: "MX", dial_code: "+52" },
    { name: "Chile", code: "CL", dial_code: "+56" },
    { name: "Colombia", code: "CO", dial_code: "+57" },
    { name: "South Africa", code: "ZA", dial_code: "+27" },
    { name: "Nigeria", code: "NG", dial_code: "+234" },
    { name: "Kenya", code: "KE", dial_code: "+254" },
    { name: "Egypt", code: "EG", dial_code: "+20" },
    { name: "Saudi Arabia", code: "SA", dial_code: "+966" },
    { name: "Qatar", code: "QA", dial_code: "+974" },
    { name: "Kuwait", code: "KW", dial_code: "+965" },
    { name: "Oman", code: "OM", dial_code: "+968" },
    { name: "Bahrain", code: "BH", dial_code: "+973" },
    { name: "Pakistan", code: "PK", dial_code: "+92" },
    { name: "Bangladesh", code: "BD", dial_code: "+880" },
    { name: "Sri Lanka", code: "LK", dial_code: "+94" },
    { name: "Nepal", code: "NP", dial_code: "+977" },
    { name: "Indonesia", code: "ID", dial_code: "+62" },
    { name: "Malaysia", code: "MY", dial_code: "+60" },
    { name: "Philippines", code: "PH", dial_code: "+63" },
    { name: "Thailand", code: "TH", dial_code: "+66" },
    { name: "Vietnam", code: "VN", dial_code: "+84" },
    { name: "Japan", code: "JP", dial_code: "+81" },
    { name: "China", code: "CN", dial_code: "+86" },
    { name: "Hong Kong", code: "HK", dial_code: "+852" },
    { name: "South Korea", code: "KR", dial_code: "+82" },
    { name: "Russia", code: "RU", dial_code: "+7" },
    { name: "Turkey", code: "TR", dial_code: "+90" },
    { name: "Israel", code: "IL", dial_code: "+972" }
];

export default countryCodes;
